var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.75 3C0.335786 3 0 3.33579 0 3.75V5.25C0 5.66421 0.335786 6 0.75 6H23.25C23.6642 6 24 5.66421 24 5.25V3.75C24 3.33579 23.6642 3 23.25 3H0.75Z","key":0}),React.createElement("path",{"d":"M0 11.25C0 10.8358 0.335786 10.5 0.75 10.5H23.25C23.6642 10.5 24 10.8358 24 11.25V12.75C24 13.1642 23.6642 13.5 23.25 13.5H0.75C0.335786 13.5 0 13.1642 0 12.75V11.25Z","key":1}),React.createElement("path",{"d":"M0 18.75C0 18.3358 0.335786 18 0.75 18H23.25C23.6642 18 24 18.3358 24 18.75V20.25C24 20.6642 23.6642 21 23.25 21H0.75C0.335786 21 0 20.6642 0 20.25V18.75Z","key":2})]);
}

Menu.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Menu;

Menu.default = Menu;
